export const logoutMutation = /* GraphQL */ `
  mutation logout {
    logout
  }
`;
